import { render, staticRenderFns } from "./payment-channel.vue?vue&type=template&id=cc46c6ca&scoped=true"
import script from "./payment-channel.vue?vue&type=script&lang=ts"
export * from "./payment-channel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc46c6ca",
  null
  
)

export default component.exports